import React from "react";
import styled, {css} from "styled-components";
import {Box} from "@mui/material";
import search from "assets/images/icons/search.svg";
import ticket from "assets/images/icons/ticket.svg";
import user from "assets/images/icons/user.svg";
import {useSelector} from "react-redux";
import {isMenuOpen} from "modules/selectors";
import {LanguageSelector} from "./LanguageSelector";
import {media} from "assets/css/media";

interface IIconProps {
	hideMobile?: boolean;
	hideTablet?: boolean;
}

const getMobileStyles = ({hideMobile, hideTablet}: IIconProps) => {
	if (hideTablet) {
		return css`
			@media (max-width: ${media.large_desktop}) {
				display: none;
			}
		`;
	}
	if (hideMobile) {
		return css`
			@media (max-width: ${media.mobile}) {
				display: none;
			}
		`;
	}
	return "";
};

const Item = styled.a<IIconProps>`
	margin-right: 16px;
	margin-left: 16px;
	${getMobileStyles}

	@media (max-width: ${media.large_desktop}) {
		margin-right: 8px;
		margin-left: 8px;
	}
`;

export const MenuIcons: React.FC = () => {
	const isMobileMenuOpen = useSelector(isMenuOpen);

	return (
		<Box
			sx={{
				display: "flex",
				justifyContent: "flex-end",
				alignItems: "center",
				flex: {
					xs: "1",
					sm: "0 1 auto",
				},
			}}>
			<Item hideTablet={true}>
				<LanguageSelector />
			</Item>
			<Item hideMobile={!isMobileMenuOpen}>
				<img src={search} alt="Search" />
			</Item>
			<Item href="https://www.fifa.com/tickets" hideMobile={isMobileMenuOpen}>
				<img src={ticket} alt="Ticket" />
			</Item>
			<Item hideMobile={isMobileMenuOpen}>
				<img src={user} alt="User" />
			</Item>
		</Box>
	);
};
